import {Component, Input} from '@angular/core';
import {CommonModule} from '@angular/common';
import {AppImageComponent} from '../image/image';
import {CarouselComponent} from '../carousel/carousel.component';
import {Photo} from '../../entities/photo/photo.entity';

@Component({
  selector: 'app-inline-carousel',
  standalone: true,
  imports: [
    CommonModule,
    AppImageComponent,
    CarouselComponent,
  ],
  templateUrl: './inline-carousel.component.html',
  styleUrls: ['./inline-carousel.component.scss'],
})
export class InlineCarouselComponent {
  @Input() photos: Photo[] | null = null;

  public activeIndex = 0;
  public fullscreen = false;
  private touchStartX: number|null = null;

  public get hasPhotos(): boolean {
    return !!this.photos && this.photos.length > 0;
  }

  public get currentPhoto(): Photo | null {
    if (!this.photos || this.photos.length === 0) {
      return null;
    }
    return this.photos[this.activeIndex] ?? null;
  }

  public prev(): void {
    if (!this.hasPhotos || this.activeIndex === 0) return;
    this.activeIndex -= 1;
  }

  public next(): void {
    const length = this.photos?.length ?? 0;
    if (!this.hasPhotos || this.activeIndex >= length - 1) return;
    this.activeIndex += 1;
  }

  public openFullscreen(): void {
    if (!this.hasPhotos) return;
    this.fullscreen = true;
  }

  public closeFullscreen(): void {
    this.fullscreen = false;
  }

  public onTouchStart(event: TouchEvent): void {
    this.touchStartX = event.changedTouches[0]?.clientX ?? null;
  }

  public onTouchEnd(event: TouchEvent): void {
    if (this.touchStartX === null) return;
    const endX = event.changedTouches[0]?.clientX ?? this.touchStartX;
    const delta = endX - this.touchStartX;
    const threshold = 40;
    if (delta > threshold) {
      this.prev();
    } else if (delta < -threshold) {
      this.next();
    }
    this.touchStartX = null;
  }
}
